import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { Home, Flow, Final } from '@/pages'
import { addExitTracker, removeExitTracker, trackPage } from '@/utils/analytics'
import { addAdobeDataLayerPageView } from '@/utils/adobe-analytics-data-layer'


const routes: Array<RouteRecordRaw> = [
  {
    path: '/:locale/',
    name: 'Home',
    component: Home
  },
  {
    path: '/:locale/flow',
    name: 'Flow',
    component: Flow
  },
  {
    path: '/:locale/final',
    name: 'Summary',
    component: Final
  }
]

if (import.meta.env.NODE_ENV === 'development') {
  routes.push({
    path: '/:locale/components',
    name: 'Components',
    component: import(/* webpackChunkName: "group-dev" */ '@/pages/Components.vue')
  })
}

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (from.params.locale && from.params.locale !== to.params.locale) {
    return next('/' + from.params.locale + to.fullPath)
  }
  if (!to.name) {
    return next()
  }
  if (to.name.toString() === 'Flow') {
    const payload = {pageName: 'Flow'}
    addExitTracker(payload)
  } else {
    addAdobeDataLayerPageView({
      pageName: to.name?.toString(),
    })
    // trackPage(to.name?.toString())
    removeExitTracker()
  }
  return next()
})

export default router
